import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/user/mfa/user.mfa.updatePhone.mutation.gql"
import type {
  UserUpdateMfaPhoneMutation,
  UserUpdateMfaPhoneMutationVariables,
} from "@/v2-backoffice-client/user/mfa/__types__/user.mfa.updatePhone.mutation"

type Options = MutationHookOptions<
  UserUpdateMfaPhoneMutation,
  UserUpdateMfaPhoneMutationVariables
>

export function useUserUpdateMfaPhoneMutation(options?: Options) {
  return useMutation<
    UserUpdateMfaPhoneMutation,
    UserUpdateMfaPhoneMutationVariables
  >(mutation, options)
}
